export const APP_VERSION = "2026.05.14";

export type ChangelogEntry = {
  version: string;
  date: string; // ISO
  highlights: string[];
};

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: "2026.05.14",
    date: "2026-05-14",
    highlights: [
      "Jobs table: new Orders view with sortable columns (Order #, Product, Qty, Price, Status, Placed) — sort persists across view switches.",
      "Jobs table: view preference (Jobs vs Orders) saved per staff user with a skeleton loading state on first render.",
      "Product editor: drag-and-drop reordering for gang sheet sizes; product code editable on creation when Drip builder is enabled.",
      "Cookie consent banner and dedicated Cookie policy page added across the app.",
      "Announcements: audience groups, per-user targeting, and a mobile-optimised manager.",
    ],
  },
  {
    version: "2026.05.07",
    date: "2026-05-07",
    highlights: [
      "Order numbers stored on jobs and shown directly in the Orders view.",
      "Customer 'View as customer' impersonation banner with one-press exit (Esc).",
      "Notification preferences split per category and delivery method.",
    ],
  },
  {
    version: "2026.04.20",
    date: "2026-04-20",
    highlights: [
      "DripApps gang sheet builder integration with per-product size lists.",
      "Cutting tiers and per-product shipping overrides.",
      "Light / Dark / System theming via design tokens.",
    ],
  },
];
